import { upperCase } from "lodash";

export const AnnouncementModel = {
  id: null,
  title: "",
  html: "",
  icon: "",
  link: "",
  creationDate: "",
  expirationDate: "",
  lastUpdate: "",
  author: "",
  agency: "",
  roadway: "",
  state: "",
  state2: null,
  priority: "MEDIUM",
  eventIds: [],
  weatherDotGovId: null,
  highPriorityPageOrder: 0,
  highPriorityPage: false,
  newsItem: false,
  siteNews: false,
  construction: false,
  transit: false,
  weather: false,
  trucker: false,
};

export const getStates = async (setStates) => {
  const endpoint = "/admin/announcements/states.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setStates(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAgencies = async (setAgencies) => {
  const endpoint = "/admin/announcements/agencies.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAgencies(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getRoadways = async (setRoadways) => {
  const endpoint = "/admin/announcements/roadways.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setRoadways(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getPriorities = async (setPriorities) => {
  const endpoint = "/admin/announcements/priorities.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setPriorities(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getEvents = async (setEvents) => {
  const endpoint = "/admin/announcements/events.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setEvents(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getLinks = async (setLinks) => {
  const endpoint = "/admin/announcements/links.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setLinks(res.data);
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAdminWebFiles = async (setAdminWebFiles) => {
  const endpoint = "/admin/webfiles/webfile/images";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    res.json().then((res) => {
      if (res.data !== null && res.data !== undefined)
        setAdminWebFiles(res.data.children);
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status} : ${res.statusText}`);
    }
  } catch (err) {}
};

export const downloadAdminWebFiles = async (filename, adminWebFile) => {
  const endpoint = "/admin/webfiles" + adminWebFile + "?download=true";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      headers: { Accept: "application/octet-stream" },
    });
    res.blob().then((res) => {
      console.log("after response");
      const blob = res;
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    });
  } catch (err) {}
};

export const uploadAdminWebFiles = async (adminWebFile) => {
  const endpoint = "/admin/webfiles/webfile/images/" + adminWebFile.name;
  const form = new FormData();
  form.append("file", adminWebFile);
  try {
    const res = await fetch(
      process.env.REACT_APP_API_HOST + endpoint + "?isDirectory=false",
      {
        method: "POST",
        body: form,
      },
    );
    if (res.ok) console.log("Uploaded the file successfully " + adminWebFile);
    else {
      throw new Error(`Error ${res.status} : ${res.statusText}`);
    }
  } catch (err) {}
};

export const deleteAdminWebFiles = async (adminWebFile) => {
  const endpoint = "/admin/webfiles/" + adminWebFile;
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    if (res.ok) console.log("deleted file successfully" + adminWebFile);
    else {
      throw new Error(`Error ${res.status} : ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAnnouncements = async (
  state,
  agency,
  priority,
  roadway,
  type,
  includeExpired,
  setAnnouncements,
  setPageLoading,
  setAuthenticationChecked,
) => {
  let endpoint = "/admin/announcements/all.json?";
  if (state !== "all") endpoint = endpoint + "&state=" + state;
  if (agency !== "all") endpoint = endpoint + "&agency=" + agency;
  if (priority !== "all")
    endpoint = endpoint + "&priority=" + upperCase(priority);
  if (roadway !== "all") endpoint = endpoint + "&roadway=" + roadway;
  if (type !== "all") endpoint = endpoint + "&type=" + type;
  if (!includeExpired)
    endpoint = endpoint + "&includeExpired=" + includeExpired;
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAnnouncements(res.data);
      setPageLoading(false);
    });

    if (res.success === true) {
      setAuthenticationChecked("Success");
    } else if (
      res.error !== undefined &&
      res.error !== null &&
      res.error.code === "UNAUTHORIZED"
    ) {
      setAuthenticationChecked("UNAUTHORIZED");
    } else if (
      res.error !== undefined &&
      res.error !== null &&
      res.error.code === "FORBIDDEN"
    ) {
      setAuthenticationChecked("FORBIDDEN");
    }
    if (!res.ok) {
      if (res.status === 403) {
        setAuthenticationChecked("FORBIDDEN");
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {
    if (err.message.indexOf("401") > -1) {
      setAuthenticationChecked("UNAUTHORIZED");
    } else if (err.message.indexOf("403") > -1) {
      setAuthenticationChecked("FORBIDDEN");
    }
  }
};

export const getHPAnnouncements = async (
  state,
  agency,
  priority,
  roadway,
  type,
  includeExpired,
  setHighPriorityAnnouncements,
  setPageLoading,
  setAuthenticationChecked,
) => {
  let endpoint = "/admin/announcements/all.json?";
  if (state !== "all") endpoint = endpoint + "&state=" + state;
  if (agency !== "all") endpoint = endpoint + "&agency=" + agency;
  if (priority !== "all")
    endpoint = endpoint + "&priority=" + upperCase(priority);
  if (roadway !== "all") endpoint = endpoint + "&roadway=" + roadway;
  endpoint = endpoint + "&type=highPriority";
  endpoint = endpoint + "&includeExpired=" + false;
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setHighPriorityAnnouncements(res.data);
      setPageLoading(false);
    });

    if (res.success === true) {
      setAuthenticationChecked("Success");
    } else if (
      res.error !== undefined &&
      res.error !== null &&
      res.error.code === "UNAUTHORIZED"
    ) {
      setAuthenticationChecked("UNAUTHORIZED");
    }
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {
    if (err.message.indexOf("401") > -1) {
      setAuthenticationChecked("UNAUTHORIZED");
    }
  }
};

export const getAnnouncementLogs = async (
  announcementId,
  setAnnouncementLogs,
) => {
  const endpoint = "/admin/announcements/" + announcementId + "/logs.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAnnouncementLogs(res.data);
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const getAllAnnouncementsLogs = async (announcementIds, setAllLogs) => {
  try {
    const logPromises = announcementIds.map(async (id) => {
      const endpoint = "/admin/announcements/" + id + "/logs.json";
      try {
        const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
          method: "GET",
        });
        const data = await res.json();
        return data.data || [];
      } catch (err) {
        return [];
      }
    });

    const logsArrays = await Promise.all(logPromises);

    const allLogs = logsArrays.flat().sort((a, b) => {
      const dateA = new Date(a.timestamp);
      const dateB = new Date(b.timestamp);
      return dateB - dateA;
    });

    setAllLogs(allLogs);
  } catch (err) {
    setAllLogs([]);
  }
};

export const getAnnouncement = async (announcementId, setAnnouncement) => {
  const endpoint =
    "/admin/announcements/" + announcementId + "/announcement.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      setAnnouncement(res.data);
      var updatedIcon;
      if (res.data !== null && res.data !== undefined)
        updatedIcon = res.data.icon;
      if (
        res.data.icon !== null &&
        res.data.icon !== "" &&
        !res.data.icon.startsWith("/")
      )
        updatedIcon = "/" + res.data.icon;
      setAnnouncement((prev) => ({ ...prev, icon: updatedIcon }));
    });

    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const createAnnouncement = async (announcement) => {
  const endpoint = "/admin/announcements/announcement.json";
  announcement.creationDate = new Date().toISOString();
  announcement.lastUpdate = new Date().toISOString();
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(announcement),
    });
    res.json().then((res) => {
      console.log("res.success" + res.success);
      if (res.success) {
        alert("New Announcement Created");
      } else {
        alert(
          "Something went wrong in Announcement Creation" + res.error.message,
        );
      }
    });
  } catch (err) {
    alert("Something went wrong" + err);
  }
};

export const saveAnnouncement = async (announcement) => {
  const endpoint =
    "/admin/announcements/" + announcement.id + "/announcement.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(announcement),
    });
    res.json().then((res) => {
      if (res.success) {
        alert("Announcement has been Updated Successfully.");
      } else {
        alert("Something went wrong" + res.error.message);
      }
    });
  } catch (err) {
    alert("Something went wrong" + err);
  }
};

export const deleteAnnouncement = async (announcement) => {
  const endpoint =
    "/admin/announcements/" + announcement.id + "/announcement.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "DELETE",
    }).then((res) => {
      alert("Announcement has been Deleted Successfully.");
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
  } catch (err) {}
};

export const fetchHighPriorityAnnouncements = async () => {
  const endpoint = "/admin/announcements/reorder.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ids: [] }),
    });

    if (!res.ok) throw new Error("Failed to fetch announcements");

    const data = await res.json();
    return data;
  } catch (err) {
    console.error("Fetch error:", err);
    throw err;
  }
};

export const reorderAnnouncements = async (ids) => {
  const endpoint = "/admin/announcements/reorder.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ids: [] }),
    });

    if (!res.ok) throw new Error("Failed to reorder announcements");

    const result = await res.json();
    return result;
  } catch (err) {
    console.error("Reorder error:", err);
    throw err;
  }
};
